/**
 * Pre-compiled fr-FR messages for Avatar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  avatarLabel: (args: Record<string, string | number>) =>
    `Image d'avatar pour ${args.fullName}`,
  avatarLabelGeneric: `Generic user avatar`,
};
